<template>
  <pt-pt-feedback-table class="pt-pt-feedback-table__withData"  @getFeedbackList="getFeedbackList" :tableLabels="tableLabels"
  :page-size="page_size" :tableData="tableData" :totalNumber="totalNumber" ref="table" :isOutside="isOutside">
    <slot/>
  </pt-pt-feedback-table>
</template>

<script>
import PtPtFeedbackTable from './index'
export default {
  name: 'pt-pt-feedback-table__withData',
  components: {
    'pt-pt-feedback-table': PtPtFeedbackTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 5
    },
    paramsData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isSearch: {
      type: String
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      totalNumber: 0,
      page_size: this.pageSize,
      tableData: [],
      sign: 0,
      isOutside: false
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (!this.isFromRouter) {
        //   this.getGoodsList(0)
          this.$refs.table.resetPage()
        } else {
          this.isOutside = true
          this.getFeedbackList(this.page)
        }
        // this.sign = 0
        // this.getFeedbackList(0)
        // this.$refs.table.resetPage()
      }
    }
    // isSearch (val) {
    //   this.sign = 1
    //   this.getFeedbackList(0)
    //   this.$refs.table.resetPage()
    // }
  },
  methods: {
    getFeedbackList (page, next) {
      let data = {
        ...this.paramsData,
        pageable: {
          page: page,
          size: this.page_size
        }
      }
      this.$store.dispatch('getFeedbackList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取意见反馈列表失败')
      })
    },
    toEduce () {
      this.$refs.table.toEduce()
    }
  }
}
</script>
